import { ReactElement, useEffect } from "react";
import { getStorage } from "utils/storage-utils";
import AppConsts from "../../libs/appconst";
import Layout from "../layouts";

const Register = (): ReactElement => {

    useEffect(() => {
        var affiliateId = getStorage('logos.aid');

        if (affiliateId) {
            window.location.href = (AppConsts.Logos_APPURL + "/register?aid=" + affiliateId);
        } else {
            window.location.href = (AppConsts.Logos_APPURL + "/register");
        }
    }, []);

    return (<Layout><div></div></Layout>);
};

export default Register;